/**
 * V1B layout breakpoints — keep in sync with `styles/global.css` media queries.
 * Drawer: max-width 900px. Inventory cards: max-width 720px.
 */
export const VT_BP_DRAWER_PX = 900;
export const VT_BP_MOBILE_INVENTORY_PX = 720;
export const VT_BP_TABLET_PX = 1024;
export const VT_BP_DESKTOP_PX = 1280;
